import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { pointsBalanceStatementQueries } from '@/services/pointsBalanceStatement/pointsBalanceStatement.queries';
import { useSearch } from '@tanstack/react-router';

export const usePointsBalanceStatement = () => {
  const { sort } = useSearch({
    from: '/(app)/points-management/points-balance-statement/',
  });
  const { data, isFetched } = useQuery({
    ...pointsBalanceStatementQueries.list(),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { pointsBalanceStatementData: data?.data || [], isFetched };
};
